import React from 'react';
import { useSelector } from 'react-redux';
import { Empty } from 'antd';
import ToAddressesSetup from '../../../../controllers/ToAddressesSetup';
import Column from '../../../../../../shared/ui/Column';
import { selectors, sliceKeys, actionCreators } from '../../../../../../model';
import SelectedHousesList from '../../../../controllers/SelectedHousesList';
import ModelSearch from '../../../../../../controllers/ModelSearch';

const { selectHasHouses, selectSelectedSearch: selectSearch } =
  selectors[sliceKeys.houses];

const { selectedSearchChanged } = actionCreators[sliceKeys.houses];

const SelectedAddressesCol = ({ className }) => {
  return (
    <Column title="Адреса" action={<ToAddressesSetup />} className={className}>
      <Content />
    </Column>
  );
};

export default SelectedAddressesCol;

function Content() {
  const hasSelectedHouses = useSelector(selectHasHouses);

  if (!hasSelectedHouses) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Ничего не выбрано"
      />
    );
  }

  return (
    <SelectedHousesList>
      <ModelSearch
        selector={selectSearch}
        createAction={selectedSearchChanged}
      />
    </SelectedHousesList>
  );
}
